import { FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import AllCategoriesLogs from '../pages/categories/components/AllCategoriesLogs'
import CategoryLogs from '../pages/categories/components/CategoryLogs'
import CategoriesList from '../pages/categories/components/CategoriesList'
import AddCategory from '../pages/categories/components/AddCategory'
import AddUser from '../pages/users/components/AddUser'
import UsersList from '../pages/users/components/UsersList'
import AddSubcategory from '../pages/subcategories/components/AddSubcategory'
import SubcategoriesList from '../pages/subcategories/components/SubcategoriesList'
import SubcategoryLogs from '../pages/subcategories/components/SubcategoryLogs'
import AllSubcategoryLogs from '../pages/subcategories/components/AllSubcategoryLogs'
import AddLocation from '../pages/locations/components/AddLocation'
import LocationsList from '../pages/locations/components/LocationsList'
import AllLocationsLogs from '../pages/locations/components/AllLocationsLogs'
import LocationLogs from '../pages/locations/components/LocationLogs'
import AddPeople from '../pages/people/components/AddPeople'
import PeopleList from '../pages/people/components/PeopleList'
import EditPeople from '../pages/people/components/EditPeople'
import ViewPeople from '../pages/people/components/ViewPeople'
import AllPeoplelogs from '../pages/people/components/AllPeoplelogs'
import PeopleLogs from '../pages/people/components/PeopleLogs'
import AllUsersLogs from '../pages/users/components/AllUsersLogs'
import EditUser from '../pages/users/components/EditUser'
import UserLogs from '../pages/users/components/UserLogs'
import ViewUser from '../pages/users/components/ViewUser'
import GeneralSetting from '../pages/generalSettings/components/GeneralSetting'
import AddRole from '../pages/users/roles/components/AddRole'
import EditRole from '../pages/users/roles/components/EditRole'
import RolesList from '../pages/users/roles/components/RolesList'
import AllRolesLogs from '../pages/users/roles/components/AllRolesLogs'
import AppointmentsList from '../pages/appointments/components/AppointmentsList'
import ViewAppointment from '../pages/appointments/components/ViewAppointment'
import AllAppointmentsLogs from '../pages/appointments/components/AllAppointmentsLogs'
import AppointmentLogs from '../pages/appointments/components/AppointmentLogs'
import { permissionCheck } from '../helper-functions/PermissionCheck'
import ProfileUpdate from '../pages/accounts/components/ProfileUpdate'
import AccountSetting from '../pages/accounts/components/AccountSetting'
import AddonSettings from '../pages/addonSettings/components/AddonSettings'
import PeopleAppointments from '../pages/appointments/components/PeopleAppointments'
import { useAuth } from '../modules/auth'
import PeopleProfile from '../pages/accounts/components/PeopleProfile'
import OrganizationSettings from '../pages/organization-settings/components/OrganizationSettings'
import OrganizationSettingLogs from '../pages/organization-settings/components/OrganizationSettingLogs'
import AddOnSettingsLogs from '../pages/addonSettings/components/AddOnSettingsLogs'
import SingleRoleLog from '../pages/users/roles/components/SingleRoleLog'
import ViewAllNotifications from '../../_metronic/partials/layout/header-menus/ViewAllNotification'
import UsersPastAppointmentsList from '../pages/appointments/components/UsersPastAppointmentList'
import PeoplePastAppointmentList from '../pages/appointments/components/PeoplePastAppointmentList'
import PeopleUpcomingAppointmentList from '../pages/appointments/components/PeopleUpcomingAppointmentList'
import UsersUpcomingAppointmentList from '../pages/appointments/components/UsersUpcomingAppointmentList'
import { getIsPeople } from '../helper-functions/general_settings_helper'
import AddHoliday from '../pages/holidays/components/AddHoliday'
import HolidaysList from '../pages/holidays/components/HolidaysList'
import EditHoliday from '../pages/holidays/components/EditHoliday'
import ViewHoliday from '../pages/holidays/components/ViewHoliday'
import AddCalendarSettings from '../pages/calendar-settings/components/AddCalendarSettings'
import HolidayLogs from '../pages/holidays/components/HolidayLogs'
import HolidaysLogs from '../pages/holidays/components/HolidaysLogs'
import CalendarSettingsLogs from '../pages/calendar-settings/components/CalendarSettingsLogs'
import FullCalendarWidget from '../../_metronic/partials/widgets/tables/FullCalendarWidget'
import AddAppointment from '../pages/appointments/components/AddAppointment'
import ProtectedRoute from './ProtectedRoute'
import PaymentStatusHandler from '../pages/appointments/components/PaymentStatusHandler'
import WeeklyAvailability from '../pages/users/components/WeeklyAvailability'

var category_create, category_activity_log, category_view
var subcategory_create, subcategory_activity_log, subcategory_view
var location_create, location_activity_log, location_view
var people_create, people_activity_log, people_view, people_edit
var appointment_activity_log, appointment_view
var user_create, user_activity_log, user_view, user_edit
var role_create, role_activity_log, role_view, role_edit
var generalsettings_view
var generatsettings_activity_log
var addonsettings_view, addonsettings_activity_log
var calendar_setting_info_create, calendar_setting_info_view, calendarsettinginfo_activity_log
var holiday_create, holiday_view
var holiday_update, holiday_delete, holiday_log, appointment_create
const PrivateRoutes = () => {
  category_create = permissionCheck('category-create')
  category_activity_log = permissionCheck('category-activity-log')
  category_view = permissionCheck('category-view')

  subcategory_create = permissionCheck('subcategory-create')
  subcategory_activity_log = permissionCheck('subcategory-activity-log')
  subcategory_view = permissionCheck('subcategory-view')

  location_create = permissionCheck('location-create')
  location_activity_log = permissionCheck('location-activity-log')
  location_view = permissionCheck('location-view')

  appointment_activity_log = permissionCheck('appointment-activity-log')
  appointment_view = permissionCheck('appointment-view')

  people_create = permissionCheck('people-create')
  people_activity_log = permissionCheck('people-activity-log')
  people_view = permissionCheck('people-view')
  people_edit = permissionCheck('people-update')

  user_create = permissionCheck('user-create')
  user_activity_log = permissionCheck('user-activity-log')
  user_view = permissionCheck('user-view')
  user_edit = permissionCheck('user-update')

  role_create = permissionCheck('role-create')
  role_activity_log = permissionCheck('role-activity-log')
  role_view = permissionCheck('role-view')
  role_edit = permissionCheck('role-update')

  generalsettings_view = permissionCheck('generatsettings-view')
  generatsettings_activity_log = permissionCheck("generatsettings-activity-log")
  addonsettings_view = permissionCheck('addonsettings-view')
  addonsettings_activity_log = permissionCheck("addonsettings-activity-log")
  calendar_setting_info_view = permissionCheck('calendarsettinginfo-view')
  calendar_setting_info_create = permissionCheck('calendarsettinginfo-create')
  holiday_view = permissionCheck("holiday-view")
  holiday_create = permissionCheck("holiday-create")
  holiday_update = permissionCheck("holiday-update")
  holiday_delete = permissionCheck("holiday-delete")
  holiday_log = permissionCheck('holiday-activity-log')
  calendarsettinginfo_activity_log = permissionCheck('calendarsettinginfo-activity-log')
  appointment_create = permissionCheck('appointment-create')
  const { auth } = useAuth();
  // const isPeople = auth?.user?.is_people;
  const isPeople = getIsPeople();
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Auth redirect */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />

        {/* Dashboard */}
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardWrapper />
            </ProtectedRoute>
          }
        />

        {/* Notifications */}
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <ViewAllNotifications />
            </ProtectedRoute>
          }
        />

        {/* Categories */}
        {category_create && (
          <Route
            path="/categories/add-category"
            element={
              <ProtectedRoute>
                <AddCategory />
              </ProtectedRoute>
            }
          />
        )}
        {category_view && (
          <Route
            path="/categories/categories-list"
            element={
              <ProtectedRoute>
                <CategoriesList />
              </ProtectedRoute>
            }
          />
        )}
        {category_activity_log && (
          <Route
            path="/categories/category-logs"
            element={
              <ProtectedRoute>
                <CategoryLogs />
              </ProtectedRoute>
            }
          />
        )}
        {category_activity_log && (
          <Route
            path="/categories/all-categories-logs"
            element={
              <ProtectedRoute>
                <AllCategoriesLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Users */}
        {user_create && (
          <Route
            path="/users/add-user"
            element={
              <ProtectedRoute>
                <AddUser />
              </ProtectedRoute>
            }
          />
        )}
        {user_view && (
          <Route
            path="/users/users-list"
            element={
              <ProtectedRoute>
                <UsersList />
              </ProtectedRoute>
            }
          />
        )}
        {user_activity_log && (
          <Route
            path="/users/all-users-logs"
            element={
              <ProtectedRoute>
                <AllUsersLogs />
              </ProtectedRoute>
            }
          />
        )}
        {user_edit && (
          <Route
            path="/users/edit-user"
            element={
              <ProtectedRoute>
                <EditUser />
              </ProtectedRoute>
            }
          />
        )}
        {user_view && (
          <Route
            path="/users/view-user"
            element={
              <ProtectedRoute>
                <ViewUser />
              </ProtectedRoute>
            }
          />
        )}
        {user_activity_log && (
          <Route
            path="/users/user-logs"
            element={
              <ProtectedRoute>
                <UserLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Roles */}
        {role_create && (
          <Route
            path="/users/roles/add-role"
            element={
              <ProtectedRoute>
                <AddRole />
              </ProtectedRoute>
            }
          />
        )}
        {role_edit && (
          <Route
            path="/users/roles/edit-role"
            element={
              <ProtectedRoute>
                <EditRole />
              </ProtectedRoute>
            }
          />
        )}
        {role_view && (
          <Route
            path="/users/roles/roles-list"
            element={
              <ProtectedRoute>
                <RolesList />
              </ProtectedRoute>
            }
          />
        )}
        {role_activity_log && (
          <Route
            path="/users/roles/role-logs"
            element={
              <ProtectedRoute>
                <SingleRoleLog />
              </ProtectedRoute>
            }
          />
        )}
        {role_activity_log && (
          <Route
            path="/users/roles/all-roles-logs"
            element={
              <ProtectedRoute>
                <AllRolesLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Subcategories */}
        {subcategory_create && (
          <Route
            path="/categories/add-subcategory"
            element={
              <ProtectedRoute>
                <AddSubcategory />
              </ProtectedRoute>
            }
          />
        )}
        {subcategory_view && (
          <Route
            path="/categories/subcategories-list"
            element={
              <ProtectedRoute>
                <SubcategoriesList />
              </ProtectedRoute>
            }
          />
        )}
        {subcategory_activity_log && (
          <Route
            path="/categories/subcategory-logs"
            element={
              <ProtectedRoute>
                <SubcategoryLogs />
              </ProtectedRoute>
            }
          />
        )}
        {subcategory_activity_log && (
          <Route
            path="/categories/all-subcategories-logs"
            element={
              <ProtectedRoute>
                <AllSubcategoryLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Locations */}
        {location_create && (
          <Route
            path="/locations/add-location"
            element={
              <ProtectedRoute>
                <AddLocation />
              </ProtectedRoute>
            }
          />
        )}
        {location_view && (
          <Route
            path="/locations/locations-list"
            element={
              <ProtectedRoute>
                <LocationsList />
              </ProtectedRoute>
            }
          />
        )}
        {location_activity_log && (
          <Route
            path="/locations/all-locations-logs"
            element={
              <ProtectedRoute>
                <AllLocationsLogs />
              </ProtectedRoute>
            }
          />
        )}
        {location_activity_log && (
          <Route
            path="/locations/location-logs"
            element={
              <ProtectedRoute>
                <LocationLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Appointments */}
        {appointment_view && (
          <Route
            path="/appointments/appointments-list"
            element={
              <ProtectedRoute>
                <AppointmentsList />
              </ProtectedRoute>
            }
          />
        )}
        {isPeople && (
          <Route
            path="/appointments/people-appointments-list"
            element={
              <ProtectedRoute>
                <PeopleAppointments />
              </ProtectedRoute>
            }
          />
        )}
        {appointment_view && (
          <Route
            path="/appointments/past-appointments-list"
            element={
              <ProtectedRoute>
                <UsersPastAppointmentsList />
              </ProtectedRoute>
            }
          />
        )}
        {isPeople && (
          <Route
            path="/appointments/people-past-appointments-list"
            element={
              <ProtectedRoute>
                <PeoplePastAppointmentList />
              </ProtectedRoute>
            }
          />
        )}
        {appointment_view && (
          <Route
            path="/appointments/upcoming-appointments-list"
            element={
              <ProtectedRoute>
                <UsersUpcomingAppointmentList />
              </ProtectedRoute>
            }
          />
        )}
        {isPeople && (
          <Route
            path="/appointments/people-upcoming-appointments-list"
            element={
              <ProtectedRoute>
                <PeopleUpcomingAppointmentList />
              </ProtectedRoute>
            }
          />
        )}
        {appointment_view || isPeople ? (
          <Route
            path="/appointments/view-appointment"
            element={
              <ProtectedRoute>
                <ViewAppointment />
              </ProtectedRoute>
            }
          />
        ) : (
          ''
        )}
        {appointment_activity_log || isPeople ? (
          <Route
            path="/appointments/all-appointments-logs"
            element={
              <ProtectedRoute>
                <AllAppointmentsLogs />
              </ProtectedRoute>
            }
          />
        ) : (
          ''
        )}
        {appointment_activity_log || isPeople ? (
          <Route
            path="/appointments/appointment-logs"
            element={
              <ProtectedRoute>
                <AppointmentLogs />
              </ProtectedRoute>
            }
          />
        ) : (
          ''
        )}

        {/* General settings */}
        {generalsettings_view && (
          <Route
            path="/general/add-general-setting"
            element={
              <ProtectedRoute>
                <GeneralSetting />
              </ProtectedRoute>
            }
          />
        )}
        {addonsettings_view && (
          <Route
            path="/add-on-settings"
            element={
              <ProtectedRoute>
                <AddonSettings />
              </ProtectedRoute>
            }
          />
        )}
        {addonsettings_view && addonsettings_activity_log && (
          <Route
            path="/add-on-settings/logs"
            element={
              <ProtectedRoute>
                <AddOnSettingsLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Profile */}
        <Route
          path="/accounts/profile"
          element={
            <ProtectedRoute>
              <ProfileUpdate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/change-password"
          element={
            <ProtectedRoute>
              <AccountSetting />
            </ProtectedRoute>
          }
        />

        {/* Settings routes (unprotected to allow redirect) */}
        <Route
          path="/settings/organisation-settings"
          element={<OrganizationSettings />}
        />
        {(localStorage.getItem('is_super_admin_flag') === '1' || calendar_setting_info_view || calendar_setting_info_create) && (
          <Route path="/settings/calendar-settings" element={<AddCalendarSettings />} />
        )}
        {generatsettings_activity_log && (
          <Route
            path="/settings/logs"
            element={
              <ProtectedRoute>
                <OrganizationSettingLogs />
              </ProtectedRoute>
            }
          />
        )}
        {calendarsettinginfo_activity_log && (
          <Route
            path="/settings/calendar/logs"
            element={
              <ProtectedRoute>
                <CalendarSettingsLogs />
              </ProtectedRoute>
            }
          />
        )}

        {/* Holidays */}
        {holiday_create && (
          <Route
            path="/holidays/add-holiday"
            element={
              <ProtectedRoute>
                <AddHoliday />
              </ProtectedRoute>
            }
          />
        )}
        {holiday_view && (
          <Route
            path="/holidays/list"
            element={
              <ProtectedRoute>
                <HolidaysList />
              </ProtectedRoute>
            }
          />
        )}
        {holiday_update && (
          <Route
            path="/holidays/edit-holiday"
            element={
              <ProtectedRoute>
                <EditHoliday />
              </ProtectedRoute>
            }
          />
        )}
        {holiday_log && (
          <Route
            path="/holidays/holiday-logs"
            element={
              <ProtectedRoute>
                <HolidayLogs />
              </ProtectedRoute>
            }
          />
        )}
        {holiday_log && (
          <Route
            path="/holidays/holidays-logs"
            element={
              <ProtectedRoute>
                <HolidaysLogs />
              </ProtectedRoute>
            }
          />
        )}
        {holiday_view && (
          <Route
            path="/holidays/view-holiday"
            element={
              <ProtectedRoute>
                <ViewHoliday />
              </ProtectedRoute>
            }
          />
        )}

        {/* Calendar */}
        {(localStorage.getItem('is_super_admin_flag') === '1' || calendar_setting_info_view || calendar_setting_info_create) && (
          <Route
            path="/users/user-calendar-view"
            element={
              <ProtectedRoute>
                <FullCalendarWidget />
              </ProtectedRoute>
            }
          />
        )}
        {/* Users Weekly Availibility */}
        {(localStorage.getItem('is_super_admin_flag') === '1' || 1) && (
          <Route
            path="/users/weekly-availibility"
            element={
              <ProtectedRoute>
                <WeeklyAvailability />
              </ProtectedRoute>
            }
          />
        )}

        {/* Appointments */}
        {appointment_create && (
          <Route
            path="/appointments/add"
            element={
              <ProtectedRoute>
                <AddAppointment />
              </ProtectedRoute>
            }
          />
        )}
        <Route
          path="/payment-status"
          element={
            <ProtectedRoute>
              <PaymentStatusHandler />
            </ProtectedRoute>
          }
        />

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="dashboard" />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
